import React, { forwardRef } from "react"

import { Badge } from "@mantine/core"

import { useLanguage } from "../../../../contexts/language-context"
import { colorPerStatus, DeviceStatusLabels } from "../../hooks/useInferStatus"

type DeviceStatusSelectItemProps = { value: DeviceStatusLabels }

const DeviceStatusSelectItem = forwardRef<HTMLDivElement, DeviceStatusSelectItemProps>(({ value, ...rest }, ref) => {
    const { L } = useLanguage()

    return (
        <div ref={ref} {...rest}>
            <Badge color={colorPerStatus[value]} variant="filled" size="sm">
                {L(value)}
            </Badge>
        </div>
    )
})

export default DeviceStatusSelectItem
